// GoogleカレンダーのURL
export const URLS = {
  GOOGLE_CALENDAR: "https://calendar.app.google/nYfpP8oUthjNHHrx6",
};
